// sessionStorage key holding the `sub` of the user for whom the GTM `login`
// event has already been sent in THIS tab session. Keying the dedupe on the
// user id (rather than a bare boolean) makes `login` fire exactly once per
// sign-in: it re-fires for a different user or after a logout→login, but NOT on
// a plain refresh or a silent token renew. Read/written by PostLoginTracker and
// cleared on logout by useLogin.signOut.
export const LOGIN_TRACKED_SUB_KEY = "travel_login_tracked_sub";
